import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import moment from "moment";
import Baja from "../../Baja";
import ClientesInfo from "./ClientesInfo";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import { abrirPDF } from "../../../../utils/abrirPDF";

const ESTADOS_MEXICO = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila",
  "Colima",
  "Durango",
  "Estado de México",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatán",
  "Zacatecas",
];

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_BONIFICACIONES_RECURRENTES = process.env.REACT_APP_URL_BONIFICACIONES_RECURRENTES;
  const URL_CONCEPTOS_BONIFICACIONES = process.env.REACT_APP_URL_CONCEPTOS_BONIFICACIONES;
  const URL_CUENTAS_CLIENTES = process.env.REACT_APP_URL_CUENTAS_CLIENTES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  const [clientes, setClientes] = useState([]);
  const [clienteEdit, setClienteEdit] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  const [idPassword, setIdPassword] = useState("");
  const [idEditCliente, setIdEditCliente] = useState("");
  const [selectedGrupoEdit, setSelectedGrupoEdit] = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("");
  const [RFC, setRFC] = useState("");
  const [calle, setCalle] = useState("");
  const [numero_ext, setNumeroExt] = useState("");
  const [numero_int, setNumeroInt] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [cp, setCP] = useState("");
  const [colonia, setColonia] = useState("");
  const [codigo, setCodigo] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [telefono, setTelefono] = useState("");
  const [celular, setCelular] = useState("");
  const [oficina, setOficina] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [casa, setCasa] = useState("");
  const [celular2, setCelular2] = useState("");
  const [celular3, setCelular3] = useState("");
  const [conocido, setConocido] = useState("");
  const [telefono2, setTelefono2] = useState("");
  const [telefono3, setTelefono3] = useState("");
  const [listaPrecios, setListaPrecios] = useState("A");
  const [email, setEmail] = useState("");
  const [emailViejo, setEmailViejo] = useState("");
  const [idInfo, setIdInfo] = useState("");
  const [plazo, setPlazo] = useState("");
  const [selectedContacto, setSelectedContacto] = useState("");
  const [selectedContactoName, setSelectedContactoName] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [ultimo_pago, setUltimoPago] = useState("");
  const [forma_pago, setFormaPago] = useState("");  
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");
  const [selected_grupo_name, setSelectedGrupoName] = useState("");
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [cuentas, setCuentas] = useState([]);
  const [idClienteCuenta, setIdClienteCuenta] = useState("");

  const [modalCuenta, setModalCuenta] = useState(false);
  const toggleCuenta = () => setModalCuenta(!modalCuenta);

  const [activo, setActivo] = useState("");
  const [contacto, setContacto] = useState("");
  const [grupo, setGrupo] = useState("");
  // Filtros por fecha de última y próxima llamada (rango; vacío = sin límite)
  const [ultLlamadaDesde, setUltLlamadaDesde] = useState("");
  const [ultLlamadaHasta, setUltLlamadaHasta] = useState("");
  const [proxLlamadaDesde, setProxLlamadaDesde] = useState("");
  const [proxLlamadaHasta, setProxLlamadaHasta] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalBoni, setModalBoni] = useState(false);
  const toggleBoni = () => setModalBoni(!modalBoni);
  const [conceptosBonificaciones, setConceptosBonificaciones] = useState([]);
  const [boniCliente, setBoniCliente] = useState([]);
  const [idClienteBoni, setIdClienteBoni] = useState("");
  const [clienteBoniName, setClienteBoniName] = useState("");

   // Direcciones Sucursal
   const [sucursales, setSucursales] = useState([]);
   const [idClienteSucursal, setIdClienteSucursal] = useState("");
   const [modalSucursal, setModalSucursal] = useState(false);
   const toggleSucursal = () => setModalSucursal(!modalSucursal);
 
   const [abrirSucursal, setAbrirSucursal] = useState(false);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      fecha:"",
      concepto: "",
      fijo:"",
      porcentaje: 0,
      importe: 0,
      observaciones: "NA",
      },
  ]);

  const [inputFieldsCuentas, setInputFieldsCuentas] = useState([
    {
      id: uuidv4(),
      banco: "",
      cuenta:"",
    },
  ]);

  const [inputFieldsSuc, setInputFieldsSuc] = useState([
    {
      id: uuidv4(),
      alias: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC:"",
      razon_social:"",
      regFiscal: ""
    },
  ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        // Array para pagination
        let arrayTabla = allClientes
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              telefono: a.telefono,
              email: a.email,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              pais: a.pais,
              estado: a.estado,
              ciudad: a.ciudad,
              delegacion: a.delegacion,
              colonia: a.colonia,
              codigo: a.codigo,
              cp: a.cp,
              celular: a.celular,
              oficina: a.oficina,
              whatsapp: a.whatsapp,
              casa: a.casa,
              celular2: a.celular2,
              celular3: a.celular3,
              conocido: a.conocido,
              telefono2: a.telefono2,
              telefono3: a.telefono3,
              listaPrecios: a.listaPrecios,
              nombre_comercial: a.nombre_comercial,
              razon_social: a.razon_social,
              RFC: a.RFC,
              grupo: a.grupos[0].name,
              idGrupo: a.grupos[0]._id,
              contacto: a.contacto[0].nombre + " " + a.contacto[0].apellido,
              idContacto: a.contacto[0]._id,
              observaciones: a.observaciones,
              ultimo_pago: a.ultimo_pago,
              forma_pago: a.forma_pago,
              plazo: a.plazo,
              regFiscal: a.regFiscal,
              usoCFDI: a.usoCFDI,
              formaPagoSAT: a.formaPagoSAT,
              condicionesPagoSAT: a.condicionesPagoSAT,
              metodoPagoSAT: a.metodoPagoSAT,
              ultimoPedido: a.ultimoPedido,
              ultimoSurtido: a.ultimoSurtido,
              ultimaLlamada: a.ultimaLlamada,
              proximaLlamada: a.proximaLlamada,
              saldo: a.saldo || 0,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setClientes(allClientes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGrupos = response.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_BONIFICACIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allConceptosBonificaciones = response.data;
        setConceptosBonificaciones(allConceptosBonificaciones);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Fecha dentro del rango; si hay filtro y el cliente no tiene fecha, no pasa
  const enRango = (fecha, desde, hasta) => {
    if (!desde && !hasta) return true;
    if (!fecha) return false;
    return (!desde || fecha >= desde) && (!hasta || fecha <= hasta);
  };

  // Mismos filtros para la tabla, el PDF, el Excel y el mail
  function filtrarClientes(lista) {
    const q = (search || "").toLowerCase();
    return lista.filter(
      (c) =>
        (!q ||
          (c.nombre_comercial || "").toLowerCase().includes(q) ||
          (c.email || "").toLowerCase().includes(q) ||
          (c.grupo || "").toLowerCase().includes(q) ||
          (c.codigo || "").toLowerCase().includes(q) ||
          (c.contacto || "").toLowerCase().includes(q)) &&
        (!grupo || grupo === "0" || c.idGrupo === grupo) &&
        (!contacto || contacto === "0" || c.idContacto === contacto) &&
        (!activo || c.activo === activo) &&
        enRango(c.ultimaLlamada, ultLlamadaDesde, ultLlamadaHasta) &&
        enRango(c.proximaLlamada, proxLlamadaDesde, proxLlamadaHasta)
    );
  }

  const fmtSaldo = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);
  // Saldo a favor de la empresa (> 1 centavo) = debe
  const textoSaldo = (saldo) => (saldo > 0.01 ? `Debe ${fmtSaldo(saldo)}` : "No debe");

  // Renglones del PDF / mail, en el orden del listado (por nombre)
  function renglonesPDF() {
    return filtrarClientes(comments)
      .slice()
      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
      .map((a) => [
        a.nombre_comercial,
        a.telefono,
        a.grupo,
        a.contacto,
        a.ultimaLlamada ? moment(a.ultimaLlamada).format("DD/MM/YYYY") : "",
        a.proximaLlamada ? moment(a.proximaLlamada).format("DD/MM/YYYY") : "",
        textoSaldo(a.saldo),
      ]);
  }
  const ENCABEZADO_PDF = [["Nombre", "Telefono", "Zona", "Contacto", "Ult. Llamada", "Prox. Llamada", "Saldo"]];

  // Texto de los filtros de llamadas aplicados (va en el PDF debajo del título)
  function textoFiltrosLlamadas() {
    const rango = (d, h) =>
      `${d ? moment(d).format("DD/MM/YYYY") : "..."} a ${h ? moment(h).format("DD/MM/YYYY") : "..."}`;
    const partes = [];
    if (ultLlamadaDesde || ultLlamadaHasta) partes.push(`Ult. llamada: ${rango(ultLlamadaDesde, ultLlamadaHasta)}`);
    if (proxLlamadaDesde || proxLlamadaHasta) partes.push(`Prox. llamada: ${rango(proxLlamadaDesde, proxLlamadaHasta)}`);
    return partes.join("   ");
  }

  // Pinta en rojo "Debe ..." en la columna de saldo
  const pintarSaldo = (data) => {
    if (data.section === "body" && data.column.index === 6 && String(data.cell.raw).startsWith("Debe")) {
      data.cell.styles.textColor = [185, 28, 28];
      data.cell.styles.fontStyle = "bold";
    }
  };

  function PDFTabla() {
    const dataPDFLimpia = renglonesPDF();
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Clientes`, 20, 40);
    const filtros = textoFiltrosLlamadas();
    if (filtros) {
      doc.setFontSize(10);
      doc.text(filtros, 20, 46);
    }
    const totalDeuda = filtrarClientes(comments).reduce((t, c) => t + (c.saldo > 0.01 ? c.saldo : 0), 0);
    doc.autoTable({
      head: ENCABEZADO_PDF,
      body: dataPDFLimpia,
      startY: filtros ? 50 : 45,
      didParseCell: pintarSaldo,
      foot: [["", "", "", "", "", `${dataPDFLimpia.length} clientes`, `Deben ${fmtSaldo(totalDeuda)}`]],
      showFoot: "lastPage",
    });
    abrirPDF(doc);
  }

  function excel() {
    const dataExcelLimpia = filtrarClientes(comments)
      .slice()
      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
      .map((a) => ({
        Nombre: a.nombre_comercial,
        Telefono: a.telefono,
        Mail: a.email,
        Zona: a.grupo,
        Contacto: a.contacto,
        UltimaLlamada: a.ultimaLlamada || "",
        ProximaLlamada: a.proximaLlamada || "",
        Saldo: a.saldo > 0.01 ? a.saldo : 0,
        Debe: a.saldo > 0.01 ? "Si" : "No",
      }));

    var option = {};

    option.fileName = "ListadoClientes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoClientes",
        sheetFilter: ["Nombre", "Telefono", "Mail", "Zona", "Contacto", "UltimaLlamada", "ProximaLlamada", "Saldo", "Debe"],
        sheetHeader: ["Nombre", "Telefono", "Mail", "Zona", "Contacto", "Ult. Llamada", "Prox. Llamada", "Saldo", "Debe"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const dataPDFLimpia = renglonesPDF();
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Clientes`, 20, 40);
    const filtrosMail = textoFiltrosLlamadas();
    if (filtrosMail) {
      doc.setFontSize(10);
      doc.text(filtrosMail, 20, 46);
    }
    doc.autoTable({
      head: ENCABEZADO_PDF,
      body: dataPDFLimpia,
      startY: filtrosMail ? 50 : 45,
      didParseCell: pintarSaldo,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Clientes",
          email: mailTo,
          fileName: "ListadoClientes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    idEdit,
    telefono,
    email,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    nombre_comercial,
    razon_social,
    RFC,
    gruposName,
    gruposId,
    contactoNombre,
    contactoId,
    observaciones,
    ultimo_pago,
    forma_pago,
    usoCFDI, 
    regFiscal, 
    formaPagoSAT,
    condicionesPagoSAT,
    metodoPagoSAT,
    codigo,
    plazo,
    celular,
    oficina,
    whatsapp,
    casa,
    celular2,
    celular3,
    conocido,
    telefono2,
    telefono3,
    listaPrecios,
  ) {
    setTelefono(telefono);
    setCelular(celular);
    setOficina(oficina);
    setWhatsapp(whatsapp);
    setCasa(casa);
    setCelular2(celular2);
    setCelular3(celular3);
    setConocido(conocido);
    setTelefono2(telefono2);
    setTelefono3(telefono3);
    setListaPrecios(listaPrecios || "A");
    setEmail(email);
    setEmailViejo(email);
    setCalle(calle);
    setNumeroExt(numero_ext);
    setNumeroInt(numero_int);
    setPais(pais);
    setEstado(estado);
    setCiudad(ciudad);
    setDelegacion(delegacion);
    setColonia(colonia);
    setCP(cp);
    setNombreComercial(nombre_comercial);
    setRazonSocial(razon_social);
    setRFC(RFC);
    setSelectedGrupoName(gruposName);
    setSelectedGrupoEdit(gruposId);
    setSelectedContactoName(contactoNombre);
    setSelectedContacto(contactoId);
    setObservaciones(observaciones);
    setUltimoPago(ultimo_pago);
    setFormaPago(forma_pago);
    setusoCFDI(usoCFDI)
    setRegFiscal(regFiscal)
    setFormaPagoSAT(formaPagoSAT);
    setCondicionesPagoSAT(condicionesPagoSAT);
    setMetodoPagoSAT(metodoPagoSAT);
    setCodigo(codigo);
    setIdEditCliente(idEdit);
    setPlazo(plazo);
    toggleEdit();
  }

  function Info(id) {
    setIdInfo(id);
    toggle();
  }

  // Ticket 3: guarda última/próxima llamada editada en línea desde el listado
  function guardaLlamada(idCliente, campo, valor) {
    axios
      .patch(
        `${URL_CLIENTES}/${idCliente}`,
        { [campo]: valor },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        // Para que los filtros y el PDF usen la fecha recién capturada
        setComments((prev) => prev.map((c) => (c._id === idCliente ? { ...c, [campo]: valor } : c)));
        Swal.fire({
          icon: "success",
          title: "Guardado",
          showConfirmButton: false,
          timer: 800,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo guardar",
        });
        console.log(error);
      });
  }

  function editClientes(event) {
    event.preventDefault();
    const URL_CLIENTES_EDIT = `${process.env.REACT_APP_URL_CLIENTES}/${idEditCliente}`;

        axios.patch(
          URL_CLIENTES_EDIT,
          {
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            telefono,
            celular,
            oficina,
            whatsapp,
            casa,
            celular2,
            celular3,
            conocido,
            telefono2,
            telefono3,
            listaPrecios,
            email,
            grupos: selectedGrupoEdit,
            contacto: selectedContacto,
            observaciones,
            ultimo_pago,
            forma_pago,
            usoCFDI,
            regFiscal,
            formaPagoSAT,
            condicionesPagoSAT,
            metodoPagoSAT,
            codigo,
            plazo: parseFloat(plazo) || 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cliente",
            detalle: `${nombre_comercial}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Telefono", field: "telefono", sortable: false },
    { name: "Email", field: "email", sortable: true },
    { name: "Zona", field: "grupo", sortable: true },
    { name: "Contacto", field: "contacto", sortable: true },
    { name: "Ult. Pedido", field: "ultimoPedido", sortable: true },
    { name: "Ult. Surtido", field: "ultimoSurtido", sortable: true },
    { name: "Ult. Llamada", field: "ultimaLlamada", sortable: false },
    { name: "Prox. Llamada", field: "proximaLlamada", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = filtrarClientes(comments);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        // Campos sin valor (cliente sin pedidos, sin email...) no deben tronar el orden
        (a, b) => reversed * String(a[sorting.field] || "").localeCompare(String(b[sorting.field] || ""))
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, contacto, grupo, activo, ultLlamadaDesde, ultLlamadaHasta, proxLlamadaDesde, proxLlamadaHasta]); // eslint-disable-line react-hooks/exhaustive-deps


  function jalaBoni(id, name){
    setIdClienteBoni(id)
    setClienteBoniName(name)

    axios
      .get(`${URL_BONIFICACIONES_RECURRENTES}Cliente/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBoniCliente = response.data;
       let arrayTabla =  allBoniCliente.map((a)=>{
          return{
            id: a._id,
            fecha: a.fecha,
            concepto: a.conceptosBonificaciones[0]._id,
            fijo: a.fijo,
            porcentaje: a.porcentaje,
            importe: a.importe,
            observaciones: a.observaciones,
            is_active: a.is_active
          }
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);
        setBoniCliente(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

      toggleBoni()
  }


  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputExistentes = (id, event) => {
    const newBoniCliente = boniCliente.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setBoniCliente(newBoniCliente);
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        fecha:"",
        concepto: "",
        fijo:"",
        porcentaje: 0,
        importe: 0,
        observaciones: "NA",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
  };

  function saveBoni() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará la bonificacion",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
        let totalMails = inputFields.length + boniCliente.length

        inputFields.map((a) => {
          if (a.porcentaje > 0 || a.importe > 0) {
            axios
              .post(
                URL_BONIFICACIONES_RECURRENTES,
                {
                  fecha: a.fecha,
                  importe: a.importe,
                  porcentaje: a.porcentaje,
                  clientes: idClienteBoni,
                  conceptosBonificaciones: a.concepto,
                  observaciones: a.observaciones,
                  fijo: a.fijo
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
               totalMails = totalMails - 1;
                if (totalMails == 0) {

                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                 
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            totalMails = totalMails - 1;
          }
        })

        boniCliente.map((a) => {
            axios
              .patch(
                `${URL_BONIFICACIONES_RECURRENTES}/${a.id}`,
                {
                  fecha: a.fecha,
                  importe: a.importe,
                  porcentaje: a.porcentaje,
                  conceptosBonificaciones: a.concepto,
                  observaciones: a.observaciones,
                  fijo: a.fijo
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
               totalMails = totalMails - 1;
                if (totalMails == 0) {

                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                 
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
        });
      }
    });
  }

  function altaBoni(id) {
            axios
              .patch(
                `${URL_BONIFICACIONES_RECURRENTES}/${id}`,
                {
                  is_active: "Si"
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                    Swal.fire("Good job!", "Creado con exito", "success");

                    const newBoniCliente = boniCliente.map((i) => {
                      if (id === i.id) {
                        i.is_active = "Si";
                      }
                      return i;
                    });
                    setBoniCliente(newBoniCliente);
                 
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
  }

  function bajaBoni(id) {
    axios
      .patch(
        `${URL_BONIFICACIONES_RECURRENTES}/${id}`,
        {
          is_active: "No"
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then((data) => {
            Swal.fire("Good job!", "Creado con exito", "success");
            const newBoniCliente = boniCliente.map((i) => {
              if (id === i.id) {
                i.is_active = "No";
              }
              return i;
            });
            setBoniCliente(newBoniCliente);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
}

function cue(id, nombre_comercial) {
  setIdClienteCuenta(id);
  setNombreComercial(nombre_comercial);
  axios
    .get(`${URL_CUENTAS_CLIENTES}/cliente/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allCuentas = res.data;
      setCuentas(allCuentas);
    })
    .catch((err) => {
      console.log(err);
    });
  toggleCuenta();
}

const handleChangeInputCuentasExistentes = (id, event) => {
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setCuentas(newCuentas);
};

const handleChangeInputCuentas = (id, event) => {
  const newInputFieldsCuentas = inputFieldsCuentas.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsCuentas(newInputFieldsCuentas);
};

function saveCuenta() {
  let totalCuen = cuentas.length + inputFieldsCuentas.length;
  cuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .patch(
          `${URL_CUENTAS_CLIENTES}/${a._id}`,
          {
            cuenta: a.cuenta,
            banco: a.banco,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuentas Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });

  // agregar inputFields
  inputFieldsCuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .post(
          `${URL_CUENTAS_CLIENTES}`,
          {
            clientes: idClienteCuenta,
            cuenta: a.cuenta,
            banco: a.banco,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuenta Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });
}

const handleAddFieldsCuentas = () => {
  setInputFieldsCuentas([
    ...inputFieldsCuentas,
    {
      id: uuidv4(),
      banco: "",
      cuenta:"",
    },
  ]);
};

const handleRemoveFieldsCuentas = (id) => {
  const values = [...inputFieldsCuentas];
  values.splice(
    values.findIndex((value) => value.id === id),
    1
  );
  setInputFieldsCuentas(values);
};

function altaCuenta(id) {
  axios
    .patch(
      `${URL_CUENTAS_CLIENTES}/${id}`,
      {
        is_active: "Si"
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then((data) => {
          Swal.fire("Good job!", "Creado con exito", "success");

          const newCuentas = cuentas.map((i) => {
            if (id === i._id) {
              i.is_active = "Si";
            }
            return i;
          });
          setCuentas(newCuentas);
       
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        // footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

function bajaCuenta(id) {
axios
.patch(
`${URL_CUENTAS_CLIENTES}/${id}`,
{
is_active: "No"
},
{
headers: {
  Authorization: `Bearer: ${localStorage.getItem(
    "app_token"
  )}`,
},
}
)
.then((data) => {
  Swal.fire("Good job!", "Creado con exito", "success");
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i.is_active = "No";
    }
    return i;
  });
  setCuentas(newCuentas);
})
.catch((error) => {
Swal.fire({
icon: "error",
title: "Oops...",
text: "Something went wrong!",
// footer: `${error.response.data}`,
});
console.log(error);
});
}


function dir(id, nombre_comercial) {
  setIdClienteSucursal(id);
  setNombreComercial(nombre_comercial)
  axios
    .get(`${URL_SUCURSALES}/clientes/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allSucursales = res.data;
      setSucursales(allSucursales);
    })
    .catch((err) => {
      console.log(err);
    });
  setAbrirSucursal(true);
}

const handleChangeInputExistentesSuc = (id, event) => {
  const newSucursales = sucursales.map((i) => {
    if (id === i._id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setSucursales(newSucursales);
};

const handleChangeInputSuc = (id, event) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsSuc(newInputFields);
};

function saveDireccion() {
  let totalDir = sucursales.length + inputFieldsSuc.length;
  sucursales.map((a) => {
    if (a.alias != "") {
      axios
        .patch(
          `${URL_SUCURSALES}/${a._id}`,
          {
            alias: a.alias,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            RFC: a.RFC,
            razon_social: a.razon_social,
            regFiscal: a.regFiscal
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalDir = totalDir - 1;
          if (totalDir == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Sucursal",
                detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalDir = totalDir - 1;
    }
  });

  // agregar inputFields
  inputFieldsSuc.map((a) => {
    if (a.alias != "") {
      axios
        .post(
          `${URL_SUCURSALES}`,
          {
            alias: a.alias,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            clientes: idClienteSucursal,
            RFC: a.RFC,
            razon_social: a.razon_social,
            regFiscal: a.regFiscal
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalDir = totalDir - 1;
          if (totalDir == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Sucursal",
                detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalDir = totalDir - 1;
    }
  });
}

const handleAddFieldsSuc = () => {
  setInputFieldsSuc([
    ...inputFields,
    {
      id: uuidv4(),
      alias: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC:"",
      razon_social:"",
      regFiscal: ""
    },
  ]);
};


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_clientes ? (
        <div className="card col-12">
        {!abrirSucursal ? (
          <>
          <Row>
            <Col md={8}>
              {user.clientes_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ClientesCreate"
                >
                  Nuevo Cliente
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Cliente
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Clientes</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-user-tie" style={{ marginRight: 8, color: "#3b82f6" }} />
                Clientes
              </h3>
              <p className="page-subtitle">Directorio de clientes</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="filter-bar">
            <div>
              <Label>Zonas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={grupo}
                onChange={(e) => {
                  setGrupo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {grupos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </div>
            <div>
              <Label>Contacto</Label>
              <Input
                bsSize="sm"
                type="select"
                value={contacto}
                onChange={(e) => {
                  setContacto(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </div>
            <div>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </div>
            {[
              ["Ult. llamada desde", ultLlamadaDesde, setUltLlamadaDesde],
              ["Ult. llamada hasta", ultLlamadaHasta, setUltLlamadaHasta],
              ["Prox. llamada desde", proxLlamadaDesde, setProxLlamadaDesde],
              ["Prox. llamada hasta", proxLlamadaHasta, setProxLlamadaHasta],
            ].map(([etiqueta, valor, setValor]) => (
              <div key={etiqueta}>
                <Label>{etiqueta}</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={valor}
                  onChange={(e) => {
                    setValor(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            ))}
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                {
                  return (
                    <tr key={p._id}>
                      <td>{p.codigo}</td>
                      <td>{p.nombre_comercial}</td>
                      <td>{p.telefono}</td>
                      <td>{p.email}</td>
                      <td>{p.grupo}</td>
                      <td>{p.contacto}</td>
                      <td>{p.ultimoPedido}</td>
                      <td>{p.ultimoSurtido}</td>
                      <td style={{ minWidth: 140 }}>
                        <Input
                          bsSize="sm"
                          type="date"
                          defaultValue={p.ultimaLlamada}
                          onBlur={(e) => e.target.value !== (p.ultimaLlamada || "") && guardaLlamada(p._id, "ultimaLlamada", e.target.value)}
                        />
                      </td>
                      <td style={{ minWidth: 140 }}>
                        <Input
                          bsSize="sm"
                          type="date"
                          defaultValue={p.proximaLlamada}
                          onBlur={(e) => e.target.value !== (p.proximaLlamada || "") && guardaLlamada(p._id, "proximaLlamada", e.target.value)}
                        />
                      </td>
                      <td>
                          <div>
                            {/* <Button
                              color="dany"
                              size="sm"
                              onClick={(e) => Info(p._id)}
                              id="Detalle"
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button> */}
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => dir(p._id, p.nombre_comercial)}
                            >
                              <i class="fas fa-shipping-fast"></i>
                            </Button>
                            <Button
                              hidden={!user.clientes_editar}
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  p._id,
                                  p.telefono,
                                  p.email,
                                  p.calle,
                                  p.numero_ext,
                                  p.numero_int,
                                  p.pais,
                                  p.estado,
                                  p.ciudad,
                                  p.delegacion,
                                  p.colonia,
                                  p.cp,
                                  p.nombre_comercial,
                                  p.razon_social,
                                  p.RFC,
                                  p.grupo,
                                  p.idGrupo,
                                  p.contacto,
                                  p.idContacto,
                                  p.observaciones,
                                  p.ultimo_pago,
                                  p.forma_pago,
                                  p.usoCFDI, 
                                  p.regFiscal,
                                  p.formaPagoSAT,
                                  p.condicionesPagoSAT,
                                  p.metodoPagoSAT,
                                  p.codigo,
                                  p.plazo,
                                  p.celular,
                                  p.oficina,
                                  p.whatsapp,
                                  p.casa,
                                  p.celular2,
                                  p.celular3,
                                  p.conocido,
                                  p.telefono2,
                                  p.telefono3,
                                  p.listaPrecios
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>

                            <Button
                              color="success"
                              size="sm"
                              onClick={(e) => jalaBoni(p._id, p.nombre_comercial)}
                              id="Detalle"
                            >
                              <i class="fas fa-percentage"></i>
                            </Button>

                            <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    cue(p._id, p.nombre_comercial)
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>
                            {user.clientes_editar ? (
                              <Baja
                                idStatus={p._id}
                                is_active={p.activo}
                                URL_BAJA={process.env.REACT_APP_URL_CLIENTES}
                              />
                            ) : undefined}
                          </div>
                      
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
          </>
           ) : (
            <div className="card container col-md-12">
               <h3 align="center">Sucursales {nombre_comercial}</h3>
              {sucursales.map((ao) => (
            <div key={ao._id}>
              <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Alias</Label>
                  <Input
                    // bsSize="sm"
                    name="alias"
                    type="text"
                    value={ao.alias}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={3}>
                <Label className="mr-sm-2">Calle</Label>
                  <Input
                    // bsSize="sm"
                    name="calle"
                    type="text"
                    value={ao.calle}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2"># Ext</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_ext"
                    type="text"
                    value={ao.numero_ext}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2"># Int</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_int"
                    type="text"
                    value={ao.numero_int}
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Colonia</Label>
                  <Input
                    // bsSize="sm"
                    name="colonia"
                    type="text"
                    value={ao.colonia}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">CP</Label>
                  <Input
                    // bsSize="sm"
                    name="cp"
                    type="text"
                    value={ao.cp}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Delegacion</Label>
                  <Input
                    // bsSize="sm"
                    name="delegacion"
                    type="text"
                    value={ao.delegacion}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Ciudad</Label>
                  <Input
                    // bsSize="sm"
                    name="ciudad"
                    type="text"
                    value={ao.ciudad}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Estado</Label>
                  <Input
                    // bsSize="sm"
                    name="estado"
                    type="text"
                    value={ao.estado}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">Pais</Label>
                  <Input
                    // bsSize="sm"
                    name="pais"
                    type="text"
                    value={ao.pais}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">RFC</Label>
                  <Input
                    // bsSize="sm"
                    name="RFC"
                    type="text"
                    value={ao.RFC}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Razon Social</Label>
                  <Input
                    // bsSize="sm"
                    name="razon_social"
                    type="text"
                    value={ao.razon_social}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Reg Fiscal</Label>
                  <Input
                    // bsSize="sm"
                    name="regFiscal"
                    type="select"
                    value={ao.regFiscal}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                    >
                    <option value="">Reg Fiscal</option>
                 <option value="0">0</option>
                 <option value="601">601 General de Ley Personas Morales</option>
                 <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                 <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                 <option value="608">608 Demas Ingresos</option>
                 <option value="612">612 Personas Fisicas con Actividad Empresarial</option>
                 <option value="616">616 Sin Obligacion Fiscal</option>
                 <option value="621">621 Incorporacion Fiscal</option>
                 <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                 <option value="626">626 Regimen simplificado de Confianza</option>
                 </Input>
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">Alta / Baja</Label>
                <br />
                <Baja
                    idStatus={ao._id}
                    is_active={ao.is_active}
                    URL_BAJA={process.env.REACT_APP_URL_SUCURSALES}
                  />
                </Col>
              </Row>
              <br />
            </div>
          ))}

          {/* Agregar mas direcciones */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Alias</Label>
                  <Input
                    // bsSize="sm"
                    name="alias"
                    type="text"
                    value={inputField.alias}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={3}>
                <Label className="mr-sm-2">Calle</Label>
                  <Input
                    // bsSize="sm"
                    name="calle"
                    type="text"
                    value={inputField.calle}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2"># Ext</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_ext"
                    type="text"
                    value={inputField.numero_ext}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2"># Int</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_int"
                    type="text"
                    value={inputField.numero_int}
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Colonia</Label>
                  <Input
                    // bsSize="sm"
                    name="colonia"
                    type="text"
                    value={inputField.colonia}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">CP</Label>
                  <Input
                    // bsSize="sm"
                    name="cp"
                    type="text"
                    value={inputField.cp}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Delegacion</Label>
                  <Input
                    // bsSize="sm"
                    name="delegacion"
                    type="text"
                    value={inputField.delegacion}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Ciudad</Label>
                  <Input
                    // bsSize="sm"
                    name="ciudad"
                    type="text"
                    value={inputField.ciudad}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Estado</Label>
                  <Input
                    // bsSize="sm"
                    name="estado"
                    type="text"
                    value={inputField.estado}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">Pais</Label>
                  <Input
                    // bsSize="sm"
                    name="pais"
                    type="text"
                    value={inputField.pais}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">RFC</Label>
                  <Input
                    // bsSize="sm"
                    name="RFC"
                    type="text"
                    value={inputField.RFC}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Razon Social</Label>
                  <Input
                    // bsSize="sm"
                    name="razon_social"
                    type="text"
                    value={inputField.razon_social}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Reg Fiscal</Label>
                  <Input
                    // bsSize="sm"
                    name="regFiscal"
                    type="select"
                    value={inputField.regFiscal}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  >
                     <option value="">Reg Fiscal</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Fisicas con Actividad Empresarial</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                  </Input>
                </Col>
                <Col md={1}>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFieldsSuc}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
              <br />
            </div>
          ))}
          <Col md={2}>
          <Button size="sm" color="success" onClick={saveDireccion}>
            Guardar
          </Button>
          <Button
                  onClick={(e) => setAbrirSucursal(false)}
                  className="btn btn-danger"
                  id="botonListado"
                  size="sm"
                >
                  Regresar
                </Button>
          </Col>
            </div> 
          )}
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Informacion del Cliente</h4>{" "}
        </ModalHeader>
        <ModalBody>
          <ClientesInfo idCliente={idInfo} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar cliente {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-id-card" />
              <span className="form-section-title">Datos Generales</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                required
                onChange={(e) => {
                  setCodigo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Nombre Comercial</Label>
              <Input
                type="text"
                placeholder="Nombre Comercial"
                value={nombre_comercial}
                required
                onChange={(e) => {
                  setNombreComercial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Razon Social</Label>
              <Input
                type="text"
                placeholder="Razon Social"
                value={razon_social}
                onChange={(e) => {
                  setRazonSocial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>RFC</Label>
              <Input
                type="text"
                placeholder="RFC"
                value={RFC}
                onChange={(e) => {
                  setRFC(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-map-marker-alt" />
              <span className="form-section-title">Dirección</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={8}>
              <Label>Calle</Label>
              <Input
                type="text"
                placeholder="Calle"
                value={calle}
                required
                onChange={(e) => {
                  setCalle(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Ext</Label>
              <Input
                type="text"
                placeholder="No. Ext"
                value={numero_ext}
                required
                onChange={(e) => {
                  setNumeroExt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Int</Label>
              <Input
                type="text"
                placeholder="No. Int"
                value={numero_int}
                onChange={(e) => {
                  setNumeroInt(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Colonia</Label>
              <Input
                type="text"
                placeholder="Colonia"
                value={colonia}
                required
                onChange={(e) => {
                  setColonia(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>CP</Label>
              <Input
                type="text"
                placeholder="CP"
                value={cp}
                required
                onChange={(e) => {
                  setCP(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Delegacion</Label>
              <Input
                type="text"
                placeholder="Delegacion o Municipio"
                value={delegacion}
                required
                onChange={(e) => {
                  setDelegacion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Ciudad</Label>
              <Input
                type="text"
                placeholder="Ciudad"
                value={ciudad}
                required
                onChange={(e) => {
                  setCiudad(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Estado</Label>
              <Input
                type="select"
                placeholder="Estado"
                value={estado}
                required
                onChange={(e) => {
                  setEstado(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {ESTADOS_MEXICO.map((e) => (
                  <option value={e}>{e}</option>
                ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Pais</Label>
              <Input
                type="text"
                placeholder="Pais"
                value={pais}
                required
                onChange={(e) => {
                  setPais(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-phone" />
              <span className="form-section-title">Teléfonos</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label>Telefono</Label>
              <Input
                type="text"
                placeholder="Telefono"
                value={telefono}
                required
                onChange={(e) => {
                  setTelefono(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Celular</Label>
              <Input
                type="text"
                placeholder="Celular"
                value={celular}
                onChange={(e) => {
                  setCelular(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>WhatsApp</Label>
              <Input
                type="text"
                placeholder="WhatsApp"
                value={whatsapp}
                onChange={(e) => {
                  setWhatsapp(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Email</Label>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                required
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Oficina</Label>
              <Input
                type="text"
                placeholder="Oficina"
                value={oficina}
                onChange={(e) => {
                  setOficina(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Casa</Label>
              <Input
                type="text"
                placeholder="Casa"
                value={casa}
                onChange={(e) => {
                  setCasa(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Celular 2</Label>
              <Input
                type="text"
                placeholder="Celular 2"
                value={celular2}
                onChange={(e) => {
                  setCelular2(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Celular 3</Label>
              <Input
                type="text"
                placeholder="Celular 3"
                value={celular3}
                onChange={(e) => {
                  setCelular3(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Telefono 2</Label>
              <Input
                type="text"
                placeholder="Telefono 2"
                value={telefono2}
                onChange={(e) => {
                  setTelefono2(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Telefono 3</Label>
              <Input
                type="text"
                placeholder="Telefono 3"
                value={telefono3}
                onChange={(e) => {
                  setTelefono3(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Conocido</Label>
              <Input
                type="text"
                placeholder="Conocido"
                value={conocido}
                onChange={(e) => {
                  setConocido(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-briefcase" />
              <span className="form-section-title">Datos Comerciales</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Zona</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedGrupo}
                required
                onChange={(e) => {
                  setSelectedGrupo(e.target.value);
                }}
              >
                <option value="0">Selecciona una Zona</option>
                {grupos
                  .filter((a) => a.is_active !== "No" || a._id === selectedGrupo)
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Agente</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedContacto}
                required
                onChange={(e) => {
                  setSelectedContacto(e.target.value);
                }}
              >
                <option value="0">Selecciona un Contacto</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Forma de Pago</Label>
              <Input
                type="select"
                placeholder="Forma de Pago"
                value={forma_pago}
                required
                onChange={(e) => {
                  setFormaPago(e.target.value);
                }}
              >
                  <option value="Cheque">Cheque</option>
                  <option value="Deposito">Deposito</option>
                  <option value="Efectivo">Efectivo</option>
                  <option value="Nota">Nota</option>
                  <option value="Pagare">Pagare</option>
                  <option value="TDC">TDC</option>
                  <option value="Transferencia">Transferencia</option>
                  <option value="PorDefinir">Por Definir</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="number"
                min="0"
                step="1"
                placeholder="Días (ej. 45)"
                value={plazo}
                required
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
                <Label>Lista de Precios</Label>
                <Input
                  type="select"
                  placeholder="Lista de Precios"
                  value={listaPrecios}
                  onChange={(e) => {
                    setListaPrecios(e.target.value);
                  }}
                >
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="G">G</option>
                  <option value="H">H</option>
                  <option value="I">I</option>
                  <option value="J">J</option>
                </Input>
              </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-file-invoice" />
              <span className="form-section-title">Datos Fiscales</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
                <Label>Regimen Fiscal</Label>
                <Input
                  type="select"
                  placeholder="RegFiscal"
                  value={regFiscal}
                  onChange={(e) => {
                    setRegFiscal(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="624">624 Régimen de los Coordinados</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                </Input>
              </Col>
            <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Uso de CDFI
                </Label>
                <Input
                  type="select"
                  placeholder="Uso de CDFI"
                  value={usoCFDI}
                  onChange={(e) => {
                    setusoCFDI(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="G01">G01 Adquisición de mercancías</option>
                  <option value="G03">G03 Gastos en general</option>
                  </Input>
              </Col>
            <Col md={3}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>
            <Col md={3}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSAT}
                  onChange={(e) => {
                    setMetodoPagoSAT(e.target.value);
                  }}
                >

              <option value="">Selecciona</option>
              <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
              <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                </Input>
              </Col>
          </Row>
          <Row>
            <Col md={3}>
                <Label>Condiciones de Pago Fiscal</Label>
                <Input
                  type="text"
                  value={condicionesPagoSAT}
                  onChange={(e) => {
                    setCondicionesPagoSAT(e.target.value);
                  }}
                />
              </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-comment-alt" />
              <span className="form-section-title">Observaciones</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>
            <i className="fas fa-save" style={{ marginRight: 6 }} />Guardar
          </Button>
        </ModalFooter>
      </Modal>


      <Modal size="xl" isOpen={modalBoni} toggle={toggleBoni}>
        <ModalHeader toggle={toggleBoni}>
          <h4>Bonificaciones {clienteBoniName}</h4>
        </ModalHeader>
        <ModalBody>
        <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Concepto</th>
                      <th>Fijo</th>
                      <th>Porcentaje</th>
                      {/* <th>Importe</th> */}
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {boniCliente.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="date"
                            name="fecha"
                            value={a.fecha}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="concepto"
                            type="select"
                            value={a.concepto}
                            required
                            onChange={(event) => {
                              handleChangeInputExistentes(a.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {conceptosBonificaciones.map((cb) => {
                              return (
                              <option value={cb._id}>{cb.name}</option>
                              )
                            })}
                          </Input>
                        </td>
                        <td>
                          <Input
                            type="select"
                            name="fijo"
                            value={a.fijo}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          >
                            <option value="">Selecciona</option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                            </Input>
                        </td>
                        <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="porcentaje"
                            value={a.porcentaje}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td>
                        {/* <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="importe"
                            value={a.importe}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td> */}
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          {a.is_active == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaBoni(a.id)}
                            tabindex="-1"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaBoni(a.id)}
                            tabindex="-1"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                          )}
                         
                        </td>
                      </tr>
                      // </div>
                    ))}

              {inputFields.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="date"
                            name="fecha"
                            value={a.fecha}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="concepto"
                            type="select"
                            value={a.concepto}
                            required
                            onChange={(event) => {
                              handleChangeInput(a.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {conceptosBonificaciones.map((cb) => {
                              return (
                              <option value={cb._id}>{cb.name}</option>
                              )
                            })}
                          </Input>
                        </td>
                        <td>
                          <Input
                            type="select"
                            name="fijo"
                            value={a.fijo}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          >
                            <option value="">Selecciona</option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                            </Input>
                        </td>
                        <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="porcentaje"
                            value={a.porcentaje}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                        {/* <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="importe"
                            value={a.importe}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td> */}
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={inputFields.length === 1}
                            onClick={() => handleRemoveFields(a.id)}
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFields}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    ))}

                  </tbody>
                  <br />
                </Table>
                <br />
                <Row>
                <Button className="btn btn-success" onClick={saveBoni}>
                Registrar
              </Button>
                </Row>

        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal size="xl" isOpen={modalCuenta} toggle={toggleCuenta}>
        <ModalHeader toggle={toggleCuenta}>
          <h4>Cuentas {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
        <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Banco</th>
                      <th>Cuentas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentasExistentes(a._id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            required
                            maxLength="4" // Limit to 4 digits
                            pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentasExistentes(a._id, event);
                            }}
                          />
                        </td>
                        <td>
                          {a.is_active == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                          )}
                         
                        </td>
                      </tr>
                      // </div>
                    ))}

              {inputFieldsCuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputCuentas(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            required
                            maxLength="4" // Limit to 4 digits
                            pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentas(a.id, event);
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={a.length === 1}
                            onClick={() => handleRemoveFieldsCuentas(a.id)}
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFieldsCuentas}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    ))}

                  </tbody>
                  <br />
                </Table>
                <br />
                <Row>
                <Button className="btn btn-success" onClick={saveCuenta}>
                Registrar
              </Button>
                </Row>

        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoClientes;
